import { Link } from 'react-router-dom';

import config from '@/config';
import NewspaperArticleMeta from '@/pages/newspaper/slider-types/components/NewspaperArticleMeta';
import { NewspaperArticleReadTime } from '@/pages/newspaper/slider-types/components/NewspaperArticleMeta';
import Heading from '@/shared-components/text/components/Heading';
import Text from '@/shared-components/text/components/Text';
import { buildPublicContentPath } from '@/utils/contentRoutes';

import './styles/LatestArticles.css';

function buildArticleLink(article = {}) {
  return article._id ? buildPublicContentPath({ ...article, post_type: 'article' }, 'article') : '#';
}

export default function LatestArticles({
  articles = [],
  category = 'Latest',
}) {
  // Backend provides the list pre-sorted by publishedAt (fallback createdAt). Take the first 3 entries.
  const displayArticles = (Array.isArray(articles) ? articles : [])
    .filter(article => !!article)
    .slice(0, 3);

  if (displayArticles.length === 0) {
    return null;
  }

  return (
    <section className="latest-articles__container">
      <div className="latest-articles__header">
        <div className="latest-articles__heading-group">
          <Heading className="latest-articles__title">
            {category}
          </Heading>
        </div>
      </div>

      <div className="latest-articles__list">
        {displayArticles.map(article => {
          const articleLink = buildArticleLink(article);
          const coverImage = article.coverImageId
            ? `${config.app.imageServiceDomain}/${article.coverImageId}/w=1200`
            : null;
          const headline = article.title || 'Untitled';

          return (
            <Link
              key={article._id}
              to={articleLink}
              className="latest-articles__item"
              aria-label={`Read ${headline}`}
            >
              <div className="latest-articles__media">
                {coverImage ? (
                  <img
                    src={coverImage}
                    alt={headline}
                    loading="lazy"
                  />
                ) : (
                  <div
                    className="latest-articles__media-placeholder"
                    aria-hidden="true"
                  />
                )}
              </div>

              <div className="latest-articles__content">
                <NewspaperArticleMeta
                  date={article.publishedAt || article.createdAt}
                  className="latest-articles__meta"
                  dateClassName="latest-articles__date"
                  separatorClassName="latest-articles__meta-separator"
                />

                <h3 className="latest-articles__headline">{headline}</h3>

                {article.description && (
                  <Text className="latest-articles__summary" paragraph>
                    {article.description}
                  </Text>
                )}

                <div className="latest-articles__footer">
                  <NewspaperArticleReadTime
                    article={article}
                    className="latest-articles__read-time"
                  />
                </div>

                <div className="latest-articles__cta">
                  <span className="latest-articles__cta-label">Read article</span>
                  <span className="latest-articles__cta-icon" aria-hidden="true">→</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
